import SandboxPage from '../pages/sandbox-page.vue'

export default [
  {
    path: '/:slug/sandbox',
    name: 'sandbox.sandbox',
    component: SandboxPage,
  },
]
